<ui-modal
  class="options-modal"
  [isOpened]="true"
  modalTitle="Options Portfolio"
  (isOpenedChange)="closeModal()"
>
  <div class="options">
    <div class="options__table-info-group-container">
      <div class="options__table-info-container">
        <form [formGroup]="portfolioGroup">
          <div #divToScroll class="table-container">
            <table class="table-container__options" ui-table>
              <thead>
                <tr>
                  <th class="currency-pair">Currency pair</th>
                  <th class="position">Position</th>
                  <th class="product-type">Product Type</th>
                  <th class="option-type">Option Type</th>
                  <th class="notional">Notional</th>
                  <th class="currency">Currency</th>
                  <th class="strike">Strike</th>
                  <th class="barrier">Barrier</th>
                </tr>
              </thead>
              <tbody>
                <ng-container formArrayName="options">
                  <tr
                    tabindex="0"
                    *ngFor="let item of optionsArray; let i = index"
                    [formGroupName]="i"
                    (click)="selectedOptionIndex = i"
                    [ngClass]="{ 'selected-row': selectedOptionIndex === i }"
                  >
                    <td>
                      <ng-select
                        [items]="currencyPairs"
                        [searchable]="true"
                        class="report-type"
                        formControlName="currencyPair"
                        appendTo="body"
                        [clearable]="false"
                      >
                      </ng-select>
                    </td>

                    <td>
                      <ng-select
                        [items]="portfolioOptionsDropdown.position"
                        [searchable]="false"
                        class="report-type"
                        formControlName="position"
                        appendTo="body"
                        [clearable]="false"
                      >
                      </ng-select>
                    </td>

                    <td>
                      <ng-select
                        [items]="portfolioOptionsDropdown.productType"
                        [searchable]="false"
                        class="report-type"
                        formControlName="productType"
                        appendTo="body"
                        [clearable]="false"
                      >
                      </ng-select>
                    </td>

                    <td>
                      <ng-select
                        [items]="portfolioOptionsDropdown.optionType"
                        [searchable]="false"
                        class="report-type"
                        formControlName="optionType"
                        appendTo="body"
                        [clearable]="false"
                      >
                      </ng-select>
                    </td>

                    <td>
                      <input
                        type="text"
                        class="input-cell"
                        formControlName="notional"
                        [inputValidator]="['numericShorthand']"
                      />
                    </td>

                    <td>
                      <ng-select
                        [items]="currencies"
                        [searchable]="false"
                        class="report-type"
                        formControlName="currency"
                        appendTo="body"
                        [clearable]="false"
                        (focus)="currencyFocus(item)"
                      >
                      </ng-select>
                    </td>

                    <td>
                      <input
                        type="text"
                        class="input-cell"
                        formControlName="strike"
                        (blur)="strikeBlur(item)"
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        class="input-cell"
                        formControlName="barrier"
                      />
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </form>
        <div class="bottom-table-add">
          <span class="add-text-container"
            ><label class="Page-1">+</label>
            <label class="add-text" (click)="addNewOption()"
              >Add option</label
            ></span
          >
        </div>
      </div>

      <div class="options__table-info-group-container__footer">
        <button
          class="
            ui-button ui-button__header ui-button--danger ui-button--delete
          "
          [disabled]="selectedOptionIndex === null"
          (click)="deleteOption()"
        >
          Delete
        </button>
      </div>
    </div>

    <div class="options__footer">
      <ng-container>
        <button
          class="ui-button primary"
          (click)="saveChanges()"
          [disabled]="!this.portfolioGroup.get('options').valid"
        >
          Save
        </button>
      </ng-container>
    </div>
  </div>
</ui-modal>
